/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseDefinitionVersion {
    getFixupPrototypeFunction() { return BaseDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<BaseDefinitionVersion>): BaseDefinitionVersion {
        let obj = Object.assign(new BaseDefinitionVersion(), model);
        BaseDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseDefinitionVersion>): BaseDefinitionVersion {
        if (!model) return null;
        return BaseDefinitionVersion.newInstance(<BaseDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseDefinitionVersion) {
        if (!obj) return;

        models.BaseDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseDefinitionVersion): boolean {
        Object.setPrototypeOf(obj, BaseDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.version === undefined) {
            this.version = 0;
        }
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.definition) {
            models.RecordIdentity.fixupPrototype(this.definition);
        }
        if (this.predecessor) {
            models.RecordIdentity.fixupPrototype(this.predecessor);
        }
    }

    /**
     * Identifier of the version
     */
    sysId: string;

    /**
     * Version created on
     */
    createdOn: Date;

    /**
     * Version  updated on
     */
    updatedOn: Date;

    version: number;

    /**
     * Reference to the definition
     */
    definition: models.RecordIdentity;

    /**
     * Reference to the previous version
     */
    predecessor: models.RecordIdentity;

}
